import { Functionality } from '../..';
import { useCurrentUser } from '../../../../../../services/currentUser';
import {
  IntegrationConfigurationButton,
  IntegrationSetupDialogProperties
} from '../common';
import { CheckrSetupDialog } from './checkrSetupDialog';
import { useCheckrConnectionStatus } from './service';

const NAME = 'Checkr';
const LOGO_URL = '/images/integrations-logos/checkr.svg';

export const CheckrSettingsButton = ({
  functionalities,
  interactive
}: {
  functionalities: Functionality[];
  interactive: boolean;
}) => {
  const { org } = useCurrentUser();

  const [value, loading, error, refresh] = useCheckrConnectionStatus(org.id);
  const status = value || undefined;
  const active = status?.connected ?? false;

  return (
    <IntegrationConfigurationButton
      functionalities={functionalities}
      name={NAME}
      logoUrl={LOGO_URL}
      active={active}
      interactive={interactive}
      renderSetupDialog={({
        open,
        onClose,
        onFailure,
        onSuccessfulIntegration
      }: IntegrationSetupDialogProperties) => (
        <CheckrSetupDialog
          orgId={org.id}
          open={open}
          onClose={onClose}
          onFailure={onFailure}
          onSuccessfulIntegration={onSuccessfulIntegration}
          status={status}
          loading={loading}
          error={error}
          onRefresh={refresh}
        />
      )}
    />
  );
};
